module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('div', {
    staticClass: "hero",
    attrs: {
      "id": "head"
    }
  }, [_c('div', {
    directives: [{
      name: "waypoint",
      rawName: "v-waypoint",
      value: ({
        active: true,
        callback: _vm.onScroll
      }),
      expression: "{ active: true, callback: onScroll }"
    }],
    staticClass: "hero__waypoint"
  }), _c('div', {
    staticClass: "hero__overlay"
  }, [_c('div', {
    staticClass: "hero__title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  })]), _c('div', {
    staticClass: "hero__down",
    on: {
      "click": function($event) {
        _vm.moveTo(1)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "name": "home-arrow"
    }
  })], 1), _c('video', {
    directives: [{
      name: "load-directive",
      rawName: "v-load-directive"
    }],
    staticClass: "hero__video",
    attrs: {
      "loop": "loop",
      "muted": "muted",
      "autoplay": "autoplay"
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    staticClass: "home-hero__source",
    attrs: {
      "src": _vm.props.video,
      "type": "video/mp4"
    }
  }), _vm._v("Your browser does not support html5 video. ")])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40a7ae54","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/hero/hero.pug
// module id = 536
// module chunks = 1